  <h2>Set Password</h2>
  <form  autocomplete="off" (ngSubmit)="setPassword()" #setPasswordForm="ngForm">
<div class="form-group">
  <div class="form-check-label success-text highlight-text">
  Welcome to CP Online! Please set your login password below.
  </div>
</div>
<div class="form-group">
  <label for="set-password-password">Set Your Password</label>
  <div class="input-group mb-3">
    <input type="password" class="form-control login-input" id="reset-password-password"
    required [(ngModel)]="setPasswordDetails.password"
      name="set-password-password" #setPasswordPassword="ngModel">
    <div class="input-group-append">
      <button class="btn inner-input-button" type="button">
        <img src="../assets/images/ios-eye.png" width="23" alt="ios-eye">
      </button>
    </div>
  </div>
  <div [hidden]="setPasswordPassword.valid || setPasswordPassword.pristine" class="alert alert-danger">
    Password is required
  </div>
</div>
<div class="form-group">
  <label for="set-password-confirm-password">Confirm Password</label>
  <div class="input-group mb-3">
    <input type="password" class="form-control login-input" id="reset-password-confirm-password"
    required [(ngModel)]="setPasswordDetails.confirmPassword"
      name="set-password-confirm-password" #setPasswordConfirmPassword="ngModel">
    <div class="input-group-append">
      <button class="btn inner-input-button" type="button">
        <img src="../assets/images/ios-eye.png" width="23" alt="ios">
      </button>
    </div>
  </div>
</div>
<button type="submit" id="reset-password-submit" class="btn btn-outline-success btn-block"
[attr.disabled]="!setPasswordForm.form.valid  ? true : null">Set Password</button>
<div class="pt-4">
    <a class="font-small cp-hyperlink" routerLink='/terms'>Terms And Conditions</a>
  </div>
  <div class="pt-2">
    <a class="font-small cp-hyperlink" routerLink='/privacy-policy'>Privacy Policy</a>
  </div>
</form>